import { AsFoundTestTableDeviationEu1Formula } from './P621.formulas';
import { FoundResultAsFoundResultFormula } from '../../../FoundResultSection/Data/P621/P621.formulas';
import { getInstrumentUnit } from '../S72/S72.formula';
import { Result } from 'journeys/portal/Forms/Sections.constants';

export const AsFoundTestTableSectionDataP621 = (selectedTag, formName, formData) => ({
    rows: [
        {
            key: 1,
            fields: [
                {
                    key: 'ASFoundTest',
                    label: 'As-Found Test',
                    isLabel: true,
                    xs: 12,
                    fontWeight: '700',
                    labelWidth: '100%',
                    padding: '7px 0 5px 6px',
                    fontSize: '9pt'
                }
            ]
        },
        {
            key: 2,
            fields: [{
                key: 'remark',
                label: 'Remark: Sometimes as-built trip setpoint may be changed/reduced in the overspeed device configuration due to testing purposes. Record below the actual trip setpoint used during the testing.',
                isLabel: true,
                xs: 12,
                fontWeight: '600',
                labelWidth: '99%',
                padding: '5px 1px 10px 8px',
                fontSize: '8.5pt',
                color: '#ea7c34',
                marginTop: '0'
            }]
        },
        {
            key: 3,
            fields: [
                {
                    key: 'Nodata',
                    isLabel: true,
                    xs: 5
                },
                {
                    key: 'F1055AftObservedTripSetpointLabel',
                    label: `Observed Trip Setpoint ${getInstrumentUnit(formData)}`,
                    isLabel: true,
                    xs: 2,
                    fontWeight: '600',
                    textAlign: 'center',
                    labelWidth: '100%',
                    padding: '7px 0 5px 3px',
                    fontSize: '9pt'
                },
                {
                    key: 'F182AftHmireadingLabel',
                    label: 'HMI Indication',
                    isLabel: true,
                    xs: 3,
                    fontWeight: '600',
                    labelWidth: '100%',
                    textAlign: 'center',
                    fontSize: '9pt'
                },
                {
                    key: 'F183AftDeviationLabel',
                    label: `Deviation ${getInstrumentUnit(formData)}`,
                    isLabel: true,
                    xs: 2,
                    fontWeight: '600',
                    labelWidth: '100%',
                    textAlign: 'center',
                    padding: '7px 0 5px 0px',
                    fontSize: '9pt'
                }]
        },
        {
            key: 4,
            fields: [
                {
                    key: 'F650asFoundTripPoint',
                    label: `Trip Setpoint for Test ${getInstrumentUnit(formData)}`,
                    value: formData.F650asFoundTripPoint,
                    isRequired: true,
                    xs: 4,
                    type: 'number',
                    maxLength: '10',
                    labelWidth: '52.7%',
                    width: '52%',
                    height: '1.92rem',
                    marginLeft: '6px',
                    textAlign: 'center',
                },
                {
                    key: 'Nodata',
                    isLabel: true,
                    xs: 1
                },
                {
                    key: 'F1055AftObservedTripSetpoint',
                    value: formData.F1055AftObservedTripSetpoint,
                    isRequired: true,
                    type: 'number',
                    xs: 2,
                    width: '100%',
                    maxLength: '10',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '1.92rem',
                    borderRight: '0',
                },
                {
                    key: 'F182AftHmireading',
                    value: formData.F182AftHmireading,
                    isRequired: true,
                    isDropdown: true,
                    placeholder: 'Select HMI Indication',
                    options: [{ name: 'Select HMI Indication', value: '' },
                    { name: 'Equipment Tripped', value: 'Equipment Tripped' },
                    { name: 'Equipment Not Tripped', value: 'Equipment Not Tripped' }],
                    xs: 3,
                    width: '100%',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '2.28rem',
                    padding: '7px 1px',
                },
                {
                    key: 'F183AftDeviation',
                    value: AsFoundTestTableDeviationEu1Formula(formData),
                    xs: 2,
                    labelWidth: '0',
                    width: '100%',
                    textAlign: 'center',
                    height: '1.92rem',
                    borderLeft: '0',
                    borderRight: '0',
                    readOnly: true,
                    inputMarginRight: '4px'
                }]
        },
        {
            key: 5,
            fields: [
                {
                    key: 'F101AftTolerance',
                    label: `Tolerance  ${getInstrumentUnit(formData)}`,
                    value: selectedTag.DateTested ? formData?.F101AftTolerance : formData?.F101AftTolerance ?? selectedTag?.ToleranceInInstrumentEu,
                    isRequired: true,
                    xs: 4,
                    type: 'number',
                    maxLength: '10',
                    labelWidth: '52.7%',
                    width: '52%',
                    height: '1.92rem',
                    marginLeft: '6px',
                    marginBottom: '4px',
                    textAlign: 'center',
                    borderBottom: '0',
                    borderTop: '0',
                },
                {
                    key: 'Nodata',
                    isLabel: true,
                    xs: 4
                },
                {
                    key: 'F102AftResult',
                    label: Result.AS_FOUND_RESULT_LABEL,
                    value: FoundResultAsFoundResultFormula(formData),
                    readOnly: true,
                    isCalculatedNew: true,
                    xs: 4,
                    labelWidth: '99%',
                    fontWeight: '700',
                    direction: 'rtl',
                    height: '1.92rem',
                    width: '100%',
                    marginRight: '0.5rem',
                    inputMarginRight: '4px',
                    borderBottom: '0',
                    borderRight: '0',
                    borderTop: '0',
                    textAlign: 'center',
                    marginBottom: '3px',
                    marginTop: '0'

                }
            ]
        }
    ]
});
